import React, { useContext, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Input } from '@thd-olt-component-react/input';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { DESCRIPTION_CHAR_LIMIT } from '../../../utils/constants';
import PtpRichTextEditor from '../../common/PtpRichTextEditor/PtpRichTextEditor';
import Field from '../../common/Field/Field';
import { jobPostingValidators } from '../../../utils/validations';
import { calculateTextBoxRows } from '../../../utils/formatters';
import { useStore } from '../../../store';
import {
  BenefitsCheckboxes
} from '../EditableJobPostingField/JobPostingBenefits';
import FieldErrorText from '../../common/FieldErrorText/FieldErrorText';

const CreateJobPostingContent = observer(({
  jobDescription,
  setJobDescription,
  educationAndSkills,
  setEducationAndSkills,
  setJobDescriptionDirty,
  jobDescriptionDirty,
  showErrors
}) => {
  const { editedJobPosting, updateJobPostingField } = useContext(JobPostingContext);
  const { staticDataStore: { benefits } } = useStore();
  const [checkedItems, setCheckedItems] = useState([]);
  const [otherChecked, setOtherChecked] = useState(false);
  const [otherBenefit, setOtherBenefit] = useState('');

  useEffect(() => {
    updateJobPostingField('benefits', {
      choices: checkedItems,
      other: otherChecked ? otherBenefit : ''
    });
  }, [checkedItems, otherChecked, otherBenefit]);

  const resetOtherBenefits = () => {
    setOtherBenefit('');
  };
  const showBenefitsError = (showErrors.draft || showErrors.publish) && !jobPostingValidators.benefits(editedJobPosting);

  return (
    <>
      <Row>
        <Col>
          <Field
            label="Job Description"
            description="What are the job requirements?"
            required
            showError={!jobPostingValidators.jobDescription(editedJobPosting)}
            dirty={jobDescriptionDirty}
          >
            <PtpRichTextEditor
              className="text-editor-edit"
              callbackHTML={setJobDescription}
              jobDescriptionHTML={jobDescription}
              setJobDescriptionDirty={setJobDescriptionDirty}
              jobDescriptionDirty={jobDescriptionDirty}
              readOnly={false}
              showError={!jobPostingValidators.jobDescription(editedJobPosting) && (showErrors.draft || showErrors.publish)}
              testId="create-job-posting-job-description"
              errorText="Please provide details about this job"
              placeholder="Please provide details about this job and the requirements you are seeking..."
            />
          </Field>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            id="requiredEducationSkills"
            label="Required Education and Skills"
            description="Please list any specific requirements you have for candidates"
          >
            <Input
              type="textarea"
              placeholder="Must have..."
              name="requiredEducationSkills"
              value={educationAndSkills}
              maxLength={DESCRIPTION_CHAR_LIMIT}
              onChange={setEducationAndSkills}
              rows={calculateTextBoxRows(educationAndSkills, 10, document?.getElementById('requiredEducationSkills')?.getBoundingClientRect().width)}
            />
          </Field>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            id="benefits"
            label="Employee Benefits"
            description="Please list any benefits you offer to employees."
            showError={showBenefitsError}
            required
          >
            {benefits && (
              <>
                <BenefitsCheckboxes
                  setOtherBenefit={setOtherBenefit}
                  otherChecked={otherChecked}
                  setOtherChecked={setOtherChecked}
                  checkedItems={checkedItems}
                  setCheckedItems={setCheckedItems}
                  benefits={benefits}
                  resetOtherBenefits={resetOtherBenefits}
                />
                {otherChecked && (
                  <div className="create-job-posting__other-benefit">
                    Please specify other benefits:
                    <Input
                      type="text"
                      placeholder="Additional benefits"
                      value={otherBenefit}
                      onChange={setOtherBenefit}
                    />
                  </div>
                )}
              </>
            )}
            {showBenefitsError && (
              <FieldErrorText hidden={false}>
                {otherChecked ? 'Please specify your other benefit' : 'Please select an Employee Benefits option'}
              </FieldErrorText>
            )}
          </Field>
        </Col>
      </Row>
    </>
  );
});

export default CreateJobPostingContent;
